import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {QueryKey} from '../../events/hooks'
import {CreateInforWorkOrderRequest} from '../types'

type UseInforWorkOrderRequestParams = {
  plantId: string
  options?: UseMutationOptions<string, AxiosError, CreateInforWorkOrderRequest>
}

export const useInforWorkOrderRequest = ({plantId, options}: UseInforWorkOrderRequestParams) => {
  const queryClient = useQueryClient()

  return useMutation<string, AxiosError, CreateInforWorkOrderRequest>({
    mutationFn: async (payload) => {
      const path = `/shifthandover/${plantId}/infor-work-order-request`

      const mutation = await ApiClient.axiosInstance.post<string>(path, payload)
      return mutation.data
    },
    ...options,
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries({queryKey: [QueryKey, variables.eventId]})
      await options?.onSuccess?.(data, variables, context, mutation)
    }
  })
}
